import { useEffect, useState } from "react";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import {
  FaCity,
  FaArrowRight,
  FaSyncAlt,
  FaRoute,
  FaSearch,
  FaMapMarkerAlt,
  FaClock,
  FaCalendarAlt,
  FaHourglassHalf,
  FaTaxi,
  FaExclamationTriangle,
  FaCheckCircle,
} from "react-icons/fa";
import api from "../api/Api";
import Loader from "../components/booking_loader";

const tabs = [
  { id: "local", label: "Local", icon: FaCity },
  { id: "oneway", label: "One Way", icon: FaArrowRight },
  { id: "round", label: "Round Trip", icon: FaSyncAlt },
  { id: "taxi", label: "Taxi", icon: FaTaxi },
  { id: "multi", label: "Multi Way", icon: FaRoute },
];

// ADD THIS — above component
const SERVICE_TYPE_MAP = {
  local: 24,
  oneway: 27,
  round: 160,
  taxi: 25,
  multi: 26,
};
const SearchableSelect = ({
  label,
  list,
  selectedId,
  onSelect,
  disabled,
  icon: Icon,
  placeholder,
}) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    const foundItem = list.find((item) => item.city_id === selectedId);
    if (foundItem) {
      setSearchTerm(foundItem.city_name);
    } else if (!selectedId) {
      setSearchTerm("");
    }
  }, [selectedId, list]);

  const filteredList = list.filter((item) =>
    item.city_name.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  return (
    <div className="col-12 col-md-6 mb-3 position-relative">
      <div className="bg-light rounded-4 p-2 border border-light transition-all focus-ring-container">
        <label
          className="text-muted small fw-bold mb-1 ms-2 d-flex align-items-center"
          style={{
            fontSize: "0.75rem",
            textTransform: "uppercase",
            letterSpacing: "0.5px",
          }}
        >
          {Icon && <Icon className="me-2 text-primary opacity-75" size={12} />}{" "}
          {label}
        </label>
        <input
          type="text"
          className="form-control bg-transparent border-0 fw-bold text-dark px-2 pb-1 pt-0"
          style={{ fontSize: "1rem", boxShadow: "none" }}
          placeholder={placeholder || "Type pickup city name..."}
          value={searchTerm}
          disabled={disabled}
          onChange={(e) => {
            setSearchTerm(e.target.value);
            setShowDropdown(true);
            if (e.target.value === "") onSelect(null);
          }}
          onFocus={() => setShowDropdown(true)}
          onBlur={() => setTimeout(() => setShowDropdown(false), 200)}
        />
      </div>

      {showDropdown && !disabled && (
        <div
          className="position-absolute w-100 bg-white shadow-lg rounded-4 mt-1 overflow-hidden animate-slide-down"
          style={{
            zIndex: 1050,
            maxHeight: "220px",
            overflowY: "auto",
            border: "1px solid #f0f0f0",
            top: "100%",
            left: 0,
          }}
        >
          {filteredList.length > 0 ? (
            filteredList.map((item) => (
              <div
                key={item.city_id}
                className="p-3 border-bottom cursor-pointer hover-bg-light fw-semibold text-dark dropdown-item-native"
                style={{ fontSize: "0.95rem" }}
                onMouseDown={() => {
                  setSearchTerm(item.city_name);
                  onSelect(item);
                  setShowDropdown(false);
                }}
              >
                <FaMapMarkerAlt
                  className="text-muted me-2 opacity-50"
                  size={12}
                />
                {item.city_name}
              </div>
            ))
          ) : (
            <div className="p-4 text-center text-muted small fw-semibold bg-light">
              No city found
            </div>
          )}
        </div>
      )}
    </div>
  );
};

const DateInput = ({ label, value, onChange, minDate }) => {
  const inputId = `date-picker-${label.replace(/\s+/g, "-")}`;

  const getLocalToday = () => {
    const today = new Date();
    const tzOffset = today.getTimezoneOffset() * 60000;
    return new Date(Date.now() - tzOffset).toISOString().split("T")[0];
  };

  return (
    <div className="col-6 mb-3">
      <div 
        className="bg-light rounded-4 p-2 border border-light w-100 d-flex flex-column justify-content-center focus-ring-container"
        style={{ minHeight: "62px" }}
      >
        <span
          className="text-muted small fw-bold mb-1 ms-1 d-flex align-items-center"
          style={{
            fontSize: "0.70rem",
            textTransform: "uppercase",
            letterSpacing: "0.5px",
          }}
        >
          <FaCalendarAlt className="me-1 text-primary opacity-75" size={10} />{" "}
          {label}
        </span>
        <input
          id={inputId}
          type="date"
          className="form-control bg-transparent border-0 fw-bold text-dark px-1 pb-0 pt-0 custom-native-date"
          style={{ fontSize: "0.9rem", boxShadow: "none" }}
          value={value}
          min={minDate || getLocalToday()}
          onChange={onChange}
        />
      </div>
    </div>
  );
};
const TimeSelect = ({ times, value, disabled, onChange }) => {
  const inputId = "time-picker-select";
  return (
    <div className="col-6 mb-3">
      <div 
        className="bg-light rounded-4 p-2 border border-light w-100 d-flex flex-column justify-content-center focus-ring-container"
        style={{ minHeight: "62px" }}
      >
        <span
          className="text-muted small fw-bold mb-1 ms-1 d-flex align-items-center"
          style={{
            fontSize: "0.70rem",
            textTransform: "uppercase",
            letterSpacing: "0.5px",
          }}
        >
          <FaClock className="me-1 text-primary opacity-75" size={10} /> Time
        </span>
        <select
          id={inputId}
          // Changed to form-control and added text-truncate
          className="form-control bg-transparent border-0 fw-bold text-dark px-1 pb-0 pt-0 cursor-pointer text-truncate custom-native-select"
          style={{ 
            fontSize: "0.9rem", // Slightly smaller to fit long strings
            boxShadow: "none" 
          }}
          value={value}
          disabled={disabled}
          onChange={(e) => {
            const selectedId = e.target.value;
            const t = times.find(
              (x) => String(x.time_id) === String(selectedId),
            );
            onChange(t?.time_id || "", t?.time_nm || "");
          }}
        >
          <option value="">{times.length === 0 ? "No Slots" : "Select"}</option>
          {times.map((t) => (
            <option key={t.time_id} value={t.time_id}>
              {t.time_nm}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default function BookingEngine() {
  const navigate = useNavigate();
  const location = useLocation();

  const [pageLoading, setPageLoading] = useState(true);
  const [active, setActive] = useState("local");
  const [loading, setLoading] = useState(false);
  const [pickupSuggestions, setPickupSuggestions] = useState([]);
  const [dropSuggestions, setDropSuggestions] = useState([]);
  const [alertConfig, setAlertConfig] = useState({ show: false, message: "" });

  const [cities, setCities] = useState([]);
  const [taxi, setTaxi] = useState([]);
  const [durations, setDurations] = useState([]);
  const [times, setTimes] = useState([]);

  const [form, setForm] = useState({
    pickCityId: "",
    pickCityName: "",
    date: "",
    timeId: "",
    timeName: "",
    durationId: "",
    durationName: "",
    durationHours: "",
    dropCityId: "",
    dropCityName: "",
    tripType: "drop",
    taxiId: "",
    taxiName: "",
    pickupAddress: "",
    pickupLat: "",
    pickupLng: "",
    dropAddress: "",
    dropLat: "",
    dropLng: "",
    returnDate: "",
    returnTimeId: "",
    returnTimeName: "",
  });

  const [searchParams] = useSearchParams();

  useEffect(() => {
    const fetchTimes = async () => {
      try {
        const res = await api.get("/bookingRoutes/time");
        // console.log("TIMES FROM BACKEND ===", res.data);
        setTimes(
          Array.isArray(res.data)
            ? res.data
            : res.data?.data || res.data?.times || [],
        );
      } catch (err) {
        console.error("Time fetch error:", err);
      }
    };
    fetchTimes();
  }, []);

  useEffect(() => {
    const typeFromUrl = searchParams.get("type");
    if (typeFromUrl) {
      const typeMap = {
        local: "local",
        oneway: "oneway",
        roundtrip: "round",
        package: "taxi",
      };
      const mappedTab = typeMap[typeFromUrl];
      if (mappedTab) setActive(mappedTab);
    }

    if (location.state) {
      setForm((prev) => ({ ...prev, ...location.state }));
      if (location.state.activeTab) setActive(location.state.activeTab);
    }

    const initData = async () => {
      try {
        const res = await api.get("/cityRoutes/local");
        setCities(res.data);
      } catch (err) {
        console.error("City Load Error:", err);
      } finally {
        setTimeout(() => setPageLoading(false), 1500);
      }
    };
    initData();
  }, [location.state, searchParams]);

  useEffect(() => {
    if (!Array.isArray(times) || times.length === 0) return;
    if (!form.timeId) {
      const defaultSlot =
        times.find((x) => x.time_nm?.includes("10.00 AM")) || times[0];
      if (defaultSlot)
        updateForm({
          timeId: defaultSlot.time_id,
          timeName: defaultSlot.time_nm,
        });
    }
  }, [times]);

  const fetchPickupSuggestions = async (input) => {
    if (!input) return setPickupSuggestions([]);
    try {
      const res = await api.get("/location/places-autocomplete", {
        params: { input },
      });
      setPickupSuggestions(res.data.predictions || []);
    } catch (e) {
      console.error("Pickup suggestions error:", e);
    }
  };

  const fetchDropSuggestions = async (input) => {
    if (!input) return setDropSuggestions([]);
    try {
      const res = await api.get("/location/places-autocomplete", {
        params: { input },
      });
      setDropSuggestions(res.data.predictions || []);
    } catch (e) {
      console.error("Drop suggestions error:", e);
    }
  };

  const selectPickupPlace = async (place_id, description) => {
    try {
      const res = await api.get("/location/place-details", {
        params: { place_id },
      });
      updateForm({
        pickupAddress: res.data.address || description,
        pickupLat: res.data.latitude,
        pickupLng: res.data.longitude,
      });
      setPickupSuggestions([]);
    } catch (e) {
      console.error(e);
    }
  };

  const selectDropPlace = async (place_id, description) => {
    try {
      const res = await api.get("/location/place-details", {
        params: { place_id },
      });
      updateForm({
        dropAddress: res.data.address || description,
        dropLat: res.data.latitude,
        dropLng: res.data.longitude,
      });
      setDropSuggestions([]);
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    if (!form.pickCityId) return;
    if (active !== "local" && active !== "taxi") return;
    setLoading(true);
    const fetchData = async () => {
      try {
        if (active === "local") {
          const res = await api.get(`/cityRoutes/durations/${form.pickCityId}`);
          // console.log("DURATIONS API RESPONSE:", res.data);
          setDurations(res.data);
        } else if (active === "taxi") {
          const res = await api.get(`/cityRoutes/taxi/${form.pickCityId}`);
          setTaxi(res.data);
        }
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [form.pickCityId, active]);

  const updateForm = (u) => setForm((p) => ({ ...p, ...u }));

  const getFilteredTimes = (targetDateStr) => {
    if (!targetDateStr || !Array.isArray(times)) return times || [];

    // Parse the date passed into the function
    const [year, month, day] = targetDateStr.split("-").map(Number);
    const selectedDate = new Date(year, month - 1, day);

    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

    //  If selected date is in the FUTURE, return ALL times
    if (selectedDate.getTime() > today.getTime()) {
      return times;
    }

    // If selected date is in the PAST, return NO slots
    if (selectedDate.getTime() < today.getTime()) {
      return [];
    }

    // IF TODAY: Filter times after current time
    const currentTotalMinutes = now.getHours() * 60 + now.getMinutes();

    return times.filter((slot) => {
      const timeStr = String(slot.time_nm || "").trim();
      let hour = 0;
      let minute = 0;

      const match = timeStr.match(/^(\d{1,2})[:.](\d{2})/);

      if (match) {
        hour = parseInt(match[1], 10);
        minute = parseInt(match[2], 10);

        const lowerTimeStr = timeStr.toLowerCase();
        if (lowerTimeStr.includes("pm") && hour < 12) {
          hour += 12;
        } else if (lowerTimeStr.includes("am") && hour === 12) {
          hour = 0;
        }
      } else {
        return true;
      }

      const slotTotalMinutes = hour * 60 + minute;
      return slotTotalMinutes > currentTotalMinutes;
    });
  };
  // Ensure Pickup Time clears if they switch dates to "today" and the selected time is in the past
  useEffect(() => {
    if (!form.date || !form.timeId) return;

    const filteredTimes = getFilteredTimes(form.date);
    const isTimeStillValid = filteredTimes.some(
      (t) => String(t.time_id) === String(form.timeId),
    );

    if (!isTimeStillValid) {
      updateForm({ timeId: "", timeName: "" });
    }
  }, [form.date, times]);

  // Ensure Drop-off Time clears if they switch the return date to "today"
  useEffect(() => {
    if (!form.returnDate || !form.returnTimeId) return;

    const filteredTimes = getFilteredTimes(form.returnDate);
    const isTimeStillValid = filteredTimes.some(
      (t) => String(t.time_id) === String(form.returnTimeId),
    );

    if (!isTimeStillValid) {
      updateForm({ returnTimeId: "", returnTimeName: "" });
    }
  }, [form.returnDate, times]);

  const handleTabChange = (id) => {
    setActive(id);
    setForm((p) => ({
      ...p,
      durationId: "",
      dropCityId: "",
      taxiId: "",
      returnDate: "",
      returnTimeId: "",
      returnTimeName: "",
      serviceTypeId: SERVICE_TYPE_MAP[id],
    }));
  };

  const triggerAlert = (msg) => setAlertConfig({ show: true, message: msg });

  const submitForm = async () => {
    // 1. Validation logic
    if (active === "local") {
      if (!form.pickCityId || !form.durationId || !form.date || !form.timeId)
        return triggerAlert("Please fill all pickup details.");
    } else if (active === "oneway") {
      if (
        !form.pickCityId ||
        !form.pickupAddress ||
        !form.dropAddress ||
        !form.date ||
        !form.timeId
      )
        return triggerAlert("Please fill all journey details.");
    } else if (active === "round") {
      if (
        !form.pickCityId ||
        !form.dropAddress ||
        !form.date ||
        !form.returnDate ||
        !form.timeId ||
        !form.returnTimeId
      )
        return triggerAlert(
          "Please fill all round trip details including return time.",
        );
    } else if (active === "taxi") {
      if (!form.pickCityId || !form.taxiId || !form.date || !form.timeId)
        return triggerAlert("Please fill all package details.");
    }

    setLoading(true);

    let tripDistanceKm = 0;
    let tripTotalDays = 1;

    // 2. Distance & Days Calculation for One-Way and Round Trip
    if (active === "oneway" || active === "round") {
      // A. Calculate Total Days
      if (active === "round") {
        const startDate = new Date(form.date);
        const endDate = new Date(form.returnDate);
        startDate.setHours(0, 0, 0, 0);
        endDate.setHours(0, 0, 0, 0);
        const diffInTime = endDate.getTime() - startDate.getTime();
        tripTotalDays = Math.ceil(diffInTime / (1000 * 3600 * 24)) + 1;
        if (tripTotalDays <= 0) tripTotalDays = 1;
      }

      // B. Ensure we have Coordinates
      let pLat = form.pickupLat;
      let pLng = form.pickupLng;
      let dLat = form.dropLat;
      let dLng = form.dropLng;

      if (!pLat || !dLat) {
        console.log(
          "⚠️ [DEBUG] User didn't select dropdown. Geocoding raw text...",
        );
        try {
          // Convert Pickup
          if (!pLat) {
            const pRes = await api.get("/location/places-autocomplete", {
              params: { input: form.pickupAddress || form.pickCityName },
            });
            if (pRes.data.predictions.length > 0) {
              const pDetails = await api.get("/location/place-details", {
                params: { place_id: pRes.data.predictions[0].place_id },
              });
              pLat = pDetails.data.latitude;
              pLng = pDetails.data.longitude;
            }
          }
          // Convert Drop-off
          if (!dLat && form.dropAddress) {
            const dRes = await api.get("/location/places-autocomplete", {
              params: { input: form.dropAddress },
            });
            if (dRes.data.predictions.length > 0) {
              const dDetails = await api.get("/location/place-details", {
                params: { place_id: dRes.data.predictions[0].place_id },
              });
              dLat = dDetails.data.latitude;
              dLng = dDetails.data.longitude;
            }
          }
        } catch (geocodeErr) {
          console.error("❌ [DEBUG] Geocoding fallback failed:", geocodeErr);
        }
      }

      // C. Calculate Distance
      if (pLat && dLat) {
        try {
          // console.log("[DEBUG] Sending Distance Request to Backend...");
          const distanceRes = await api.get("/location/get-distance", {
            params: {
              originLat: pLat,
              originLng: pLng,
              destLat: dLat,
              destLng: dLng,
            },
          });

          tripDistanceKm =
            distanceRes.data.distanceInKm || distanceRes.data.distance || 0;

          if (tripDistanceKm <= 0) {
            throw new Error("Calculated distance is zero");
          }
        } catch (error) {
          console.error("❌ [DEBUG] Distance API FAILED!", error);
          setLoading(false);
          return triggerAlert(
            "We couldn't calculate the driving distance due to a network issue. Please check your connection and try again.",
          );
        }
      } else {
        console.error("❌ [DEBUG] Failed to find coordinates completely.");
        setLoading(false);
        return triggerAlert(
          "We couldn't pinpoint your exact locations. Please try selecting the addresses from the dropdown suggestions.",
        );
      }

      // If it's a Round Trip, multiply the one-way distance by 2
      if (active === "round") {
        tripDistanceKm = tripDistanceKm * 2;
      }
    }

    const serviceTypeId = SERVICE_TYPE_MAP[active];
    let path =
      active === "taxi"
        ? "/taxi/search"
        : active === "round"
          ? "/roundtrip/search"
          : active === "oneway"
            ? "/oneway/search"
            : "/local/search";

    setLoading(false);

    // Navigate to Tab 2
    navigate(path, {
      state: {
        ...form,
        activeTab: active,
        serviceTypeId,
        distance: tripDistanceKm,
        totalDays: tripTotalDays,
      },
    });
  };

  const TabIcon = ({ icon: Icon }) => (
    <Icon className="me-1 me-md-2" size={14} />
  );

  if (pageLoading)
    return (
      <div className="d-flex justify-content-center align-items-center min-vh-100 bg-light">
        <Loader />
      </div>
    );

  return (
    <div className="d-flex flex-column bg-light font-sans overflow-hidden">
      {alertConfig.show && (
        <div
          className="native-alert-overlay"
          onClick={() => setAlertConfig({ show: false, message: "" })}
        >
          <div
            className="native-alert-card animate-pop-in"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="p-4 text-center">
              <FaExclamationTriangle size={36} className="text-warning mb-3" />
              <h6 className="fw-bold mb-2">Missing Information</h6>
              <p className="text-muted small mb-4">{alertConfig.message}</p>
              <button
                className="btn w-100 rounded-pill py-2 fw-bold text-white shadow-sm btn-native-press"
                style={{
                  background: "linear-gradient(135deg, #ff7a00, #ff9500)",
                }}
                onClick={() => setAlertConfig({ show: false, message: "" })}
              >
                Okay
              </button>
            </div>
          </div>
        </div>
      )}

      <div
        className="container-fluid flex-grow-1 p-0"
        style={{ maxWidth: "800px", margin: "0 auto" }}
      >
        <div className="bg-white px-3 pt-3 pb-2 shadow-sm mb-3 border-bottom position-relative z-index-1">
          <div
            className="d-flex gap-2 overflow-auto pb-2 no-scrollbar"
            style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
          >
            {tabs.map((tab) => {
              const isActive = active === tab.id;
              return (
                <button
                  key={tab.id}
                  onClick={() => handleTabChange(tab.id)}
                  className={`btn rounded-pill px-3 py-2 d-flex align-items-center text-nowrap fw-semibold transition-all ${isActive ? "shadow-sm" : ""}`}
                  style={{
                    fontSize: "0.85rem",
                    backgroundColor: isActive ? "#ff7a00" : "#f8f9fa",
                    color: isActive ? "white" : "#6c757d",
                    border: isActive
                      ? "1px solid #ff7a00"
                      : "1px solid #dee2e6",
                    flexShrink: 0,
                  }}
                >
                  <TabIcon icon={tab.icon} /> {tab.label}
                </button>
              );
            })}
          </div>
        </div>

        <div className="px-3 animate-fade-in">
          <div className="card border-0 shadow-sm rounded-4 mb-4 bg-white p-3 p-md-4">
            <div className="row g-2">
              {active === "local" && (
                <>
                  <SearchableSelect
                    label="Pickup City"
                    icon={FaMapMarkerAlt}
                    list={cities}
                    selectedId={form.pickCityId}
                    onSelect={(c) =>
                      updateForm({
                        pickCityId: c?.city_id || "",
                        pickCityName: c?.city_name || "",
                      })
                    }
                  />
                  <div className="col-12 col-md-6 mb-3">
                    <div className="bg-light rounded-4 p-2 border border-light w-100 d-block mb-0 focus-ring-container">
                      <span
                        className="text-muted small fw-bold mb-1 ms-2 d-flex align-items-center"
                        style={{
                          fontSize: "0.75rem",
                          textTransform: "uppercase",
                          letterSpacing: "0.5px",
                        }}
                      >
                        <FaHourglassHalf
                          className="me-2 text-primary opacity-75"
                          size={12}
                        />{" "}
                        Duration
                      </span>
                      <select
                        className="form-select bg-transparent border-0 fw-bold text-dark px-2 pb-1 pt-0 cursor-pointer"
                        style={{ fontSize: "0.95rem", boxShadow: "none" }}
                        value={form.durationId || ""}
                        disabled={!form.pickCityId || loading}
                        onChange={(e) => {
                          const val = e.target.value;
                          const d = durations.find(
                            (x) => String(x.rentslab_id) === String(val),
                          );
                          updateForm({
                            durationId: d?.rentslab_id || "",
                            durationName: d?.rentslab_name || "",
                            durationHours: d?.hrs_covered || null,
                          });
                        }}
                      >
                        <option value="">Select Duration</option>
                        {durations.map((d) => (
                          <option key={d.rentslab_id} value={d.rentslab_id}>
                            {d.rentslab_name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="row g-2 w-100 m-0">
                    <DateInput
                      label="Date"
                      value={form.date}
                      onChange={(e) => updateForm({ date: e.target.value })}
                    />
                    <TimeSelect
                      times={getFilteredTimes(form.date)}
                      value={form.timeId}
                      disabled={!form.date}
                      onChange={(id, name) =>
                        updateForm({ timeId: id, timeName: name })
                      }
                    />
                  </div>
                </>
              )}

              {active === "oneway" && (
                <>
                  <SearchableSelect
                    label="Pick Up City / Town"
                    icon={FaMapMarkerAlt}
                    list={cities}
                    selectedId={form.pickCityId}
                    onSelect={(c) =>
                      updateForm({
                        pickCityId: c?.city_id || "",
                        pickCityName: c?.city_name || "",
                      })
                    }
                  />
                  <div className="col-12 col-md-6 mb-3 position-relative">
                    <div className="bg-light rounded-4 p-2 border border-light transition-all focus-ring-container">
                      <label
                        className="text-muted small fw-bold mb-1 ms-2 d-flex align-items-center"
                        style={{
                          fontSize: "0.75rem",
                          textTransform: "uppercase",
                          letterSpacing: "0.5px",
                        }}
                      >
                        <FaMapMarkerAlt
                          className="me-2 text-primary opacity-75"
                          size={12}
                        />
                        Pickup Location
                      </label>
                      <input
                        type="text"
                        className="form-control bg-transparent border-0 fw-bold text-dark px-2 pb-1 pt-0"
                        style={{ fontSize: "0.95rem", boxShadow: "none" }}
                        placeholder="Pickup Location"
                        value={form.pickupAddress}
                        onChange={(e) => {
                          updateForm({ pickupAddress: e.target.value });
                          fetchPickupSuggestions(e.target.value);
                        }}
                      />
                    </div>
                    {pickupSuggestions.length > 0 && (
                      <div
                        className="position-absolute w-100 bg-white shadow-lg rounded-4 overflow-hidden animate-slide-down mt-1"
                        style={{
                          maxHeight: "200px",
                          zIndex: 2000,
                          border: "1px solid #f0f0f0",
                        }}
                      >
                        {pickupSuggestions.map((item) => (
                          <div
                            key={item.place_id}
                            className="p-3 border-bottom cursor-pointer hover-bg-light fw-semibold text-dark dropdown-item-native"
                            style={{ fontSize: "0.95rem" }}
                            onMouseDown={() =>
                              selectPickupPlace(item.place_id, item.description)
                            }
                          >
                            <FaMapMarkerAlt
                              className="text-muted me-2 opacity-50"
                              size={12}
                            />
                            {item.description}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                  <div className="col-12 mb-3 position-relative">
                    <div className="bg-light rounded-4 p-2 border border-light transition-all focus-ring-container">
                      <label
                        className="text-muted small fw-bold mb-1 ms-2 d-flex align-items-center"
                        style={{
                          fontSize: "0.75rem",
                          textTransform: "uppercase",
                          letterSpacing: "0.5px",
                        }}
                      >
                        <FaMapMarkerAlt
                          className="me-2 text-primary opacity-75"
                          size={12}
                        />{" "}
                        Drop Off Location
                      </label>
                      <input
                        type="text"
                        className="form-control bg-transparent border-0 fw-bold text-dark px-2 pb-1 pt-0"
                        style={{ fontSize: "0.95rem", boxShadow: "none" }}
                        placeholder="Search Drop Location"
                        value={form.dropAddress}
                        onChange={(e) => {
                          updateForm({ dropAddress: e.target.value });
                          fetchDropSuggestions(e.target.value);
                        }}
                      />
                    </div>
                    {dropSuggestions.length > 0 && (
                      <div
                        className="position-absolute w-100 bg-white shadow-lg rounded-4 overflow-hidden animate-slide-down mt-1"
                        style={{
                          maxHeight: "200px",
                          zIndex: 2000,
                          border: "1px solid #f0f0f0",
                        }}
                      >
                        {dropSuggestions.map((item) => (
                          <div
                            key={item.place_id}
                            className="p-3 border-bottom cursor-pointer hover-bg-light fw-semibold text-dark dropdown-item-native"
                            style={{ fontSize: "0.95rem" }}
                            onMouseDown={() =>
                              selectDropPlace(item.place_id, item.description)
                            }
                          >
                            <FaMapMarkerAlt
                              className="text-muted me-2 opacity-50"
                              size={12}
                            />
                            {item.description}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                  <div className="row g-2 w-100 m-0">
                    <DateInput
                      label="Pickup Date"
                      value={form.date}
                      onChange={(e) => updateForm({ date: e.target.value })}
                    />
                    <TimeSelect
                      times={getFilteredTimes(form.date)}
                      value={form.timeId}
                      disabled={!form.date}
                      onChange={(id, name) =>
                        updateForm({ timeId: id, timeName: name })
                      }
                    />
                  </div>
                </>
              )}

              {active === "round" && (
                <>
                  <SearchableSelect
                    label="Pick Up City / Town"
                    icon={FaMapMarkerAlt}
                    list={cities}
                    selectedId={form.pickCityId}
                    onSelect={(c) =>
                      updateForm({
                        pickCityId: c?.city_id || "",
                        pickCityName: c?.city_name || "",
                      })
                    }
                  />
                  <div className="col-12 mb-3 position-relative">
                    <div className="bg-light rounded-4 p-2 border border-light transition-all focus-ring-container">
                      <label
                        className="text-muted small fw-bold mb-1 ms-2 d-flex align-items-center"
                        style={{
                          fontSize: "0.75rem",
                          textTransform: "uppercase",
                          letterSpacing: "0.5px",
                        }}
                      >
                        <FaMapMarkerAlt
                          className="me-2 text-primary opacity-75"
                          size={12}
                        />{" "}
                        Destination
                      </label>
                      <input
                        type="text"
                        className="form-control bg-transparent border-0 fw-bold text-dark px-2 pb-1 pt-0"
                        style={{ fontSize: "0.95rem", boxShadow: "none" }}
                        placeholder="Search Destination"
                        value={form.dropAddress}
                        onChange={(e) => {
                          updateForm({ dropAddress: e.target.value });
                          fetchDropSuggestions(e.target.value);
                        }}
                      />
                    </div>
                    {dropSuggestions.length > 0 && (
                      <div
                        className="position-absolute w-100 bg-white shadow-lg rounded-4 overflow-hidden animate-slide-down mt-1"
                        style={{
                          maxHeight: "200px",
                          zIndex: 2000,
                          border: "1px solid #f0f0f0",
                        }}
                      >
                        {dropSuggestions.map((item) => (
                          <div
                            key={item.place_id}
                            className="p-3 border-bottom cursor-pointer hover-bg-light fw-semibold text-dark dropdown-item-native"
                            style={{ fontSize: "0.95rem" }}
                            onMouseDown={() =>
                              selectDropPlace(item.place_id, item.description)
                            }
                          >
                            <FaMapMarkerAlt
                              className="text-muted me-2 opacity-50"
                              size={12}
                            />
                            {item.description}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                  <div className="row g-2 w-100 m-0">
                    <DateInput
                      label="Pickup Date"
                      value={form.date}
                      onChange={(e) => updateForm({ date: e.target.value })}
                    />
                    <TimeSelect
                      times={getFilteredTimes(form.date)}
                      value={form.timeId}
                      disabled={!form.date}
                      onChange={(id, name) =>
                        updateForm({ timeId: id, timeName: name })
                      }
                    />
                  </div>
                  <div className="row g-2 w-100 m-0">
                    <DateInput
                      label="Drop-off Date"
                      value={form.returnDate}
                      minDate={form.date}
                      onChange={(e) =>
                        updateForm({ returnDate: e.target.value })
                      }
                    />
                    <TimeSelect
                      times={getFilteredTimes(form.returnDate)}
                      value={form.returnTimeId}
                      disabled={!form.returnDate}
                      onChange={(id, name) =>
                        updateForm({ returnTimeId: id, returnTimeName: name })
                      }
                    />
                  </div>
                </>
              )}

              {active === "taxi" && (
                <>
                  <SearchableSelect
                    label="PickUp City / Town"
                    icon={FaMapMarkerAlt}
                    list={cities}
                    selectedId={form.pickCityId}
                    onSelect={(c) =>
                      updateForm({
                        pickCityId: c?.city_id || "",
                        pickCityName: c?.city_name || "",
                      })
                    }
                  />
                  <div className="col-12 col-md-6 mb-3">
                    <div className="bg-light rounded-4 p-2 border border-light w-100 d-block mb-0 focus-ring-container">
                      <span
                        className="text-muted small fw-bold mb-1 ms-2 d-flex align-items-center"
                        style={{
                          fontSize: "0.75rem",
                          textTransform: "uppercase",
                          letterSpacing: "0.5px",
                        }}
                      >
                        <FaTaxi
                          className="me-2 text-primary opacity-75"
                          size={12}
                        />{" "}
                        Taxi Package
                      </span>
                      <select
                        className="form-select bg-transparent border-0 fw-bold text-dark px-2 pb-1 pt-0 cursor-pointer"
                        style={{ fontSize: "0.95rem", boxShadow: "none" }}
                        value={form.taxiId || ""}
                        disabled={!form.pickCityId || loading}
                        onChange={(e) => {
                          const val = e.target.value;
                          const a = taxi.find(
                            (x) => String(x.taxi_id) === String(val),
                          );
                          updateForm({
                            taxiId: a?.taxi_id || "",
                            taxipkg: a?.airport_name || "",
                            taxiImage: a?.tour_image || "",
                          });
                        }}
                      >
                        <option value="">Select Taxi Package</option>
                        {taxi.map((a) => (
                          <option key={a.taxi_id} value={a.taxi_id}>
                            {a.airport_name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="row g-2 w-100 m-0">
                    <DateInput
                      label="Date"
                      value={form.date}
                      onChange={(e) => updateForm({ date: e.target.value })}
                    />
                    <TimeSelect
                      times={getFilteredTimes(form.date)}
                      value={form.timeId}
                      disabled={!form.date}
                      onChange={(id, name) =>
                        updateForm({ timeId: id, timeName: name })
                      }
                    />
                  </div>
                  <div className="col-12 mt-2">
                    <div className="bg-success bg-opacity-10 border border-success border-opacity-25 rounded-4 p-3">
                      <h6
                        className="fw-bold text-success mb-2"
                        style={{ fontSize: "0.85rem" }}
                      >
                        Taxi Packages Include:
                      </h6>
                      <div
                        className="d-flex flex-column gap-1 text-muted"
                        style={{ fontSize: "0.8rem" }}
                      >
                        <div className="d-flex align-items-start gap-2">
                          <FaCheckCircle
                            className="text-success mt-1 flex-shrink-0"
                            size={12}
                          />
                          <span>
                            Fuel, Toll, Parking, State-Tax & Driver Allowance
                          </span>
                        </div>
                        <div className="d-flex align-items-start gap-2">
                          <FaCheckCircle
                            className="text-success mt-1 flex-shrink-0"
                            size={12}
                          />
                          <span>No Extra Km/Hour Charges</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}

              <div className="col-12 mt-3">
                <button
                  className="btn w-100 py-3 fw-bold text-white shadow rounded-pill btn-native-press d-flex align-items-center justify-content-center gap-2"
                  style={{
                    background: "linear-gradient(135deg, #ff7a00, #ff9500)",
                    fontSize: "1.05rem",
                  }}
                  onClick={submitForm}
                  disabled={
                    loading || active === "multi" || active === "package"
                  }
                >
                  {loading ? (
                    <span className="spinner-border spinner-border-sm" />
                  ) : (
                    <FaSearch />
                  )}
                  <span>Search Cabs</span>
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* Image Section */}
        <div
          style={{ width: "100%", backgroundColor: "#fff", marginTop: "8px" }}
        >
          <p
            className="text-center fw-semibold mb-1 mt-2"
            style={{
              color: "#0ea5e9",
              fontSize: "0.78rem",
              letterSpacing: "1.5px",
              textTransform: "uppercase",
            }}
          >
            Explore Odisha with Patra Travels
          </p>
          <img
            src="/Odisha-city-skyline-02-small.jpg"
            alt="Odisha Skyline"
            style={{
              width: "100%",
              display: "block",
              objectFit: "contain",
              opacity: 0.9,
            }}
          />
        </div>
      </div>

      <style>{`
                .transition-all { transition: all 0.2s ease-in-out; }
                .no-scrollbar::-webkit-scrollbar { display: none; }
                .cursor-pointer { cursor: pointer; }
                .focus-ring-container:focus-within { border-color: #ff7a00 !important; background-color: #fff !important; box-shadow: 0 4px 12px rgba(255, 122, 0, 0.1); }
                @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
                .animate-fade-in { animation: fadeIn 0.3s ease-out; }
                @keyframes slideDown { from { opacity: 0; transform: translateY(-10px); } to { opacity: 1; transform: translateY(0); } }
                .animate-slide-down { animation: slideDown 0.2s ease-out; }
                .native-alert-overlay { position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0,0,0,0.6); z-index: 10000; display: flex; align-items: center; justify-content: center; padding: 40px; }
                .native-alert-card { background: white; border-radius: 16px; width: 100%; max-width: 320px; box-shadow: 0 12px 30px rgba(0,0,0,0.3); }
                .btn-native-press:active { transform: scale(0.97); opacity: 0.9; }
                .dropdown-item-native:active { background-color: #f1f3f5 !important; }
                .custom-native-select {
                  appearance: none;
                  -webkit-appearance: none;
                  padding-right: 0 !important;
                }

                .custom-native-date {
                  padding-right: 0 !important; 
                  position: relative; /* <-- THIS KEEPS THE INVISIBLE ICON INSIDE THE BOX */
                }

                .custom-native-date::-webkit-calendar-picker-indicator {
                  background: transparent;
                  bottom: 0;
                  color: transparent;
                  cursor: pointer;
                  height: auto;
                  left: 0;
                  position: absolute;
                  right: 0;
                  top: 0;
                  width: auto;
                }
            `}</style>
    </div>
  );
}
